import { OnSiteLocationType, OrderFulfillmentStatus, OrderMethod } from '../../../../../services/exports/Constants';

export default {
  header: 'Bestellhistorie',
  labels: {
    dummy_order: 'Test Bestellung',
    orders_number: 'Anzahl der Bestellungen ({{count}})',
    revenue: 'Umsatz: {{amount}}',
    tips: 'Trinkgeld: {{amount}}',
    cash_sales: ' ({{amount}} Bargeld)',
    refunds: 'Erstattungen: {{count}} ({{amount}})',
  },
  order_methods: {
    [OrderMethod.Pickup]: 'Abholung',
    [OrderMethod.Delivery]: 'Lieferung',
    [OrderMethod.OnSite]: {
      [OnSiteLocationType.RoomService]: 'Zimmerservice',
      [OnSiteLocationType.TableService]: 'Tischservice',
    },
  },
  statuses: {
    [OrderFulfillmentStatus.Created]: 'In Bearbeitung',
    [OrderFulfillmentStatus.Reviewed]: 'In Bearbeitung',
    [OrderFulfillmentStatus.Accepted]: 'In Bearbeitung',
    [OrderFulfillmentStatus.Preparing]: 'In Bearbeitung',
    [OrderFulfillmentStatus.Ready]: 'In Bearbeitung',
    [OrderFulfillmentStatus.OnDelivery]: 'In Bearbeitung',
    [OrderFulfillmentStatus.Picked]: 'Abgeschlossen',
    [OrderFulfillmentStatus.Rejected]: 'Storniert',
  },
  payment_methods: {
    invoice: 'Auf Rechnung',
    cash: 'Bargeld',
    online: 'Online-Methode',
  },
  filters: {
    all: 'Alle',
  },
  fields: {
    order_placed: 'DATUM',
    order_number: '#',
    customer: 'Kunde',
    payment_method: 'Zahlungsmethode',
    method: 'Typ',
    status: 'Status',
    total: 'GESAMT',
  },
  buttons: {
    print: 'Drucken',
    create_test_order: 'Testbestellung erstellen',
  },
  toasts: {
    failed_to_fetch_orders:
      'Daten konnten nicht geladen werden. Bitte klicke auf das „Aktualisieren“-Symbol oder versuche es in 1 Minute erneut.',
    something_went_wrong: 'Etwas ist schief gelaufen, bitte versuche es noch einmal.',
    failed_to_create_test_order: 'Testbestellung konnte nicht erstellt werden',
    test_order_created: 'Testbestellung erstellt',
  },
};
